import { enumCameraSortOption } from '@rematter/frontend-lib-api-client';

import { cameraDeleteAtom } from '../_graphql/mutationCameraDelete';
import { camerasListQueryAtom } from '../_graphql/queryCamerasList';

export const $remoteCameras = camerasListQueryAtom(() => ({
  variables: {
    sorting: [enumCameraSortOption.NameAsc],
  },
}));

export const $deleteCamera = cameraDeleteAtom({
  onSuccess: (get) => {
    get($remoteCameras).refetch?.();
  },
});
